/**
 * Controla una aplicación de gestión de correo
 */
class formFunctions {

  /**
   * @param {errorClass}
   * @param {successClass}
   */
  constructor(errorClass, successClass) {
    this._errorClass = errorClass;
    this._successClass = successClass;
  }

  /**
   * Valida el input
   */
  cleanForm(form) {
    $(':input', form).each(function() {
        var type = this.type;
        var tag = this.tagName.toLowerCase();
        //limpiamos los valores de los campos…
        if (type == 'text' || type == 'password' || tag == 'textarea' || type == 'email' || type == 'file')
        this.value = "";
        // excepto de los checkboxes y radios, le quitamos el checked
        // pero su valor no debe ser cambiado
        else if (type == 'checkbox' || type == 'radio')
        this.checked = false;
        // los selects le ponesmos el indice a -
        else if (tag == 'select')
        this.selectedIndex = 0;
    });
    
    $('.hundreds-form__error').hide();
    
    $('.hundreds-form__radio').each(function(){
      if ( $('label',this).hasClass( 'hundreds-validation__input_error' ) ) { $('label',this).removeClass( 'hundreds-validation__input_error' ); }
    });
    $('.hundreds-form__checkbox').each(function(){
      if ( $('label',this).hasClass( 'hundreds-validation__input_error' ) ) { $('label',this).removeClass( 'hundreds-validation__input_error' ); }
    });

    $('input').each(function(){
      if ( $(this).hasClass( 'hundreds-validation__input_error' ) ) { $(this).removeClass( 'hundreds-validation__input_error' ); }
      //$(this).removeClass(this._successClass);
      //$(this).removeClass(this._errorClass);
    });

    $('select').each(function(){
      if ( $(this).hasClass( 'hundreds-validation__input_error' ) ) { $(this).removeClass( 'hundreds-validation__input_error' ); }
      //$(this).removeClass(this._successClass);
      //$(this).removeClass(this._errorClass);
    });

    $('textarea').each(function(){
      if ( $(this).hasClass( 'hundreds-validation__input_error' ) ) { $(this).removeClass( 'hundreds-validation__input_error' ); }
      //$(this).removeClass(this._successClass);
      //$(this).removeClass(this._errorClass);
    });

  }

}

export default formFunctions;
